import * as d3 from 'd3'
export default {
  methods: {
    call_Toggle(selection) {
      selection
      .on('mouseover', function() {
        d3.select(this).transition().duration(50).attr('opacity', .7)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(200).attr('opacity', 1)
      })
      .on('click', () => {
        if(this.toggle=='ON') {
          d3.select(`#TOGGLE_${this.localId}`).attr('xlink:href', this.HOST + `/icon/toggle_OFF.svg`)
          this.toggle = 'OFF'
          this.ani_Image_OFF()
        } else if(this.toggle=='OFF') {
          d3.select(`#TOGGLE_${this.localId}`).attr('xlink:href', this.HOST + `/icon/toggle_ON.svg`)
          this.toggle = 'ON'
          this.ani_Image_ON()
        }
        
      }) 
    },

    call_ErectionBlock(selection, d) {

      selection
      .on('mouseover', ()=> {
        d3.select(`#ROW_${d.SN}_${this.localId}`).transition().duration(50).attr('opacity', .2)
      })
      .on('mouseout', ()=> {
        d3.select(`#ROW_${d.SN}_${this.localId}`).transition().duration(200).attr('opacity', 0)
      })
      .on('click', () => {
        if(this.toggle=='ON') {
          d3.select(`#TOGGLE_${this.localId}`).attr('xlink:href', this.HOST + `/icon/toggle_OFF.svg`)
          this.toggle = 'OFF'
          this.ani_Image_OFF()
        }
        d3.select(`#ROW_${this.current.idx}_${this.localId}`).transition().duration(200).attr('opacity', 0)
        d3.selectAll(`.ROW_${this.current.idx}_${this.localId}`).attr('fill', '#757575')

        let old = this.current.idx
        this.current.idx = d.SN
        this.current.blk = d.ER_BK
        d3.selectAll(`.ROW_${d.SN}_${this.localId}`).attr('fill', '#EC407A')

        this.reload_SVG(d, old)
      }) 
    },

    reload_SVG(d, old) {
      this.loadSvg(
        this.canvasForm, {
        id: `SVG_${d.SN}`, 
        x: this.table.x + 5, y: this.table.y + 5,
        url : this.HOST + `/Visualization/Erection_Status/${this.revision}/${this.current.blk}.svg`
      }).then(() => {
        d3.select(`#SVG_${d.SN}`).style('opacity', 0)
        d3.selectAll("text").style('font-family', 'roboto')

        // d3.select(`#SVG_${d.SN}`).moveToBack()
        d3.select(`#SVG_${old}`).transition().duration(600).style('opacity', 0)
        d3.select(`#SVG_${d.SN}`).transition().duration(600).style('opacity', 1)

        let x_ = 10
        d3.select(`#BLK_${this.localId}`).text(d.ER_BK)

        x_ = x_ + this.getNode(`#BLK_${this.localId}`, 'width') + 5
        d3.select(`#WT_${this.localId}`).attr('x', x_).text(`${d.MOD}`)


        x_ = 200
        d3.select(`#PLAN_${this.localId}`).attr('x', x_).text(d.P_SD)

        x_ = x_ + this.getNode(`#PLAN_${this.localId}`, 'width') + 5
        d3.select(`#DASH_${this.localId}`).attr('x', x_)

        x_ = x_ + this.getNode(`#DASH_${this.localId}`, 'width') + 5
        d3.select(`#ACT_${this.localId}`).attr('x', x_)
        .attr('font-size', (d.A_SD) ? 12 : 11)
        .attr('fill', (d.A_SD) ? '#fff' : '#333')
        .text(()=> {
          if(d.A_SD) return d.A_SD
          else return `${this.gmx_dateDiff(d.P_SD, this.cutoff)} days to go`
        })

        setTimeout(() => {
          d3.select(`#SVG_${old}`).remove()
        }, 600)
      })

    },
  }
}